import template from './voucher-collection.html';
import controller from './voucher-collection.controller';

let voucherCollectionComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default voucherCollectionComponent;
